import {
  PERMISSIONS_ACTIONS,
  RESOURCE,
  useHasAccess,
} from "@dashboard/library";

export function useCcAccess() {
  const [canRead, canCreate, canEdit, canDelete] = useHasAccess(
    [
      PERMISSIONS_ACTIONS.READ,
      PERMISSIONS_ACTIONS.CREATE,
      PERMISSIONS_ACTIONS.UPDATE,
      PERMISSIONS_ACTIONS.DELETE,
    ],
    RESOURCE.CONVERSATIONS_CENTER
  );

  return { canRead, canCreate, canEdit, canDelete };
}
